import React from "react";
import {
  Create,
  SimpleForm,
  useDataProvider,
  useNotify,
  useRefresh,
} from "react-admin";
import DocumentTitle from "../common/documentTitle/DocumentTitle";
import CreateNewStaffUserFormBody from "./ScreateNewStaffUserFormBody";
import StaffRoles from "../../helpers/UsersStaffRole";
import { RightsRow, StaffUser } from "../../types/staffUser";
import SimpleFormToolbar from "./SimpleFormToolbar";

const StaffUserCreate = (props) => {
  const [isUserBlocked, setDoesUserBlocked] = React.useState(false);
  const [rights, setRights] = React.useState(StaffRoles.AdministartorRights);
  const notify = useNotify();
  const refresh = useRefresh();
  const dataProvider = useDataProvider();

  const handleUserStatus = () => {
    setDoesUserBlocked(!isUserBlocked);
  };

  const handleChangeUserRights = (rights) => {
    setRights(rights);
  };

  const onSuccess = (
    userRights: Array<RightsRow>,
    isUserBlocked: boolean
  ) => async (data) => {
    const staffUserData: StaffUser = {
      email: data.email,
      name: data.name || "",
      surname: data.surname || "",
      isBlocked: isUserBlocked,
      permissions: userRights,
      role: data.role,
      skype: data.skype,
      startDate: data.createDate,
      id: "",
    };

    const result = await dataProvider.create("staff", { data: staffUserData });
    if (!result.data) {
      notify("something went wrong", "error");
    }
    notify(`User saved`);
    refresh();
  };

  return (
    <>
      <DocumentTitle
        core="Staff"
        secondary=""
        purpose="Add new"
        appointment="User"
      />
      <Create {...props}>
        <SimpleForm
          toolbar={
            <SimpleFormToolbar
              onSuccess={onSuccess(rights, isUserBlocked)}
              {...props}
            />
          }
          className="general-tab"
        >
          <CreateNewStaffUserFormBody
            staffUserRights={rights}
            setRights={handleChangeUserRights}
            isUserBlocked={isUserBlocked}
            handleChangeUserStatus={handleUserStatus}
            doesCreate={true}
          />
        </SimpleForm>
      </Create>
    </>
  );
};
export default StaffUserCreate;
